import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CardTransfer icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CardTransfer } from '@sravni/design-system-icons'
 *
 * <CardTransfer />
 * ```
 */
var CardTransfer = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CardTransfer", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M12.142 15h3.572c1.183 0 2.142-.96 2.142-2.143V5.714c0-1.183-.959-2.143-2.142-2.143H4.285c-1.184 0-2.143.96-2.143 2.143v7.143M2.143 6.428h15.714", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10" }),
    React.createElement("path", { d: "M4.643 9.286h3.571", stroke: "currentColor", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.571 15H2.143 8.57Z", fill: "currentColor" }),
    React.createElement("path", { d: "M8.571 15H2.143M7.856 12.857 10 15l-2.143 2.143", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CardTransfer };
//# sourceMappingURL=CardTransfer.js.map
